import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
  /**
   * 取得備註項目
   * @param commit
   * @param commentId
   * @returns {*}
   */
  fetchCommentItem({ commit }, {
    commentId
  } = {}) {
    return request
      .get(`/comment/${commentId}`, {
        ...configRequest,
        name: 'fetchCommentItem'
      })
  },
};
